/**
 * Owner Portal Feature Flags
 * 
 * Controls visibility of features in the Owner Portal.
 * All features default to false (disabled) until explicitly enabled.
 */

export const OWNER_FEATURES = {
  /**
   * Links feature - Admin-managed links (Documents & Links section)
   * When false: Links section is hidden, API calls are skipped
   * When true: Links section is shown, API calls are made
   */
  links: false,
};
